<div class="container">
  <div class="h2-component">{{'stores.ourStores.title' | cxTranslate }}</div>
</div>
@if ( !(isLoading$ | async) && (locations$ | async); as locations) {
  <div class="help-container" style="background-color: #e6e7e8">
    <div class="container">
      <div class="stores-map">
        <app-custom-store-finder-map
          #storeMap
          [locations]="locations?.stores"
          (selectedStoreItem)="selectStoreItemList($event)"
        ></app-custom-store-finder-map>
      </div>
      <div class="help-items-list auto-row">
        @for (location of locations?.stores; track location; let i = $index) {
          <app-custom-store-finder-item [location]="location" [index]="i"></app-custom-store-finder-item>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
}

